<div
  style="background: #fff;margin: 10px; border-radius: 5px;padding-bottom: 10px;padding-top: 10px;">
  <form nz-form [formGroup]="invoiceForm" class="m-4" nzLayout="vertical"
    *ngIf="staffView && mode === 'add'">

    <nz-row nzGutter="16">

      <!-- Provider PPL ID + Get Consumers button -->
      @if(staffView && mode === 'add') {
      <nz-col nzXs="24" nzSm="12" nzMd="8">
        <nz-form-item class="ppl-form-item">
          <nz-form-label nzFor="providerPplId" class="ppl-form-label">Provider
            PPL
            ID<span>*</span></nz-form-label>
          <nz-form-control class="ppl-form-control">
            <nz-row nzGutter="8" style="width: 100%;">
              <nz-col nzSpan="14">
                <input nz-input formControlName="providerPplId"
                  id="providerPplId" placeholder="Enter Provider PPL ID" />
              </nz-col>
              <nz-col nzSpan="10">
                <ppl-button label="Get Participants"
                  [customClass]="'primary-button'" [size]="'small'"
                  (click)="getConsumers()" style="width: auto"></ppl-button>
              </nz-col>
            </nz-row>
            <span *ngIf="invoiceForm.get('providerPplId')?.touched &&
                        invoiceForm.get('providerPplId')?.invalid"
              class="pl-1 error-message">
              Please enter a PPL ID to search.
            </span>
          </nz-form-control>
        </nz-form-item>
      </nz-col>
      <!-- Consumer Select -->
      <nz-col nzXs="24" nzSm="12" nzMd="8">
        <nz-form-item class="ppl-form-item">
          <nz-form-label nzFor="consumer"
            class="ppl-form-label">Participant<span>*</span></nz-form-label>
          <nz-form-control class="ppl-form-control">
            <nz-select formControlName="consumer"
              nzPlaceHolder="Select Participant" nzShowSearch>
              @for(opt of consumers; track $index){
              <nz-option [nzLabel]="opt.consumerFullName"
                [nzValue]="opt.consumerId"></nz-option>
              }
            </nz-select>
            <span *ngIf="invoiceForm.get('consumer')?.hasError('noConsumers')"
              class="pl-1 error-message">
              You don't have any active participants.
            </span>
          </nz-form-control>
        </nz-form-item>
      </nz-col>
      }
    </nz-row>
  </form>
  <div *ngIf="showInvoiceForm">
    <div style="display: flex; justify-content: flex-end; padding-right: 21px; margin-bottom: 10px;"
       *ngIf="mode === 'actions' && staffView && !isReadOnly">
      <ppl-button (click)="onPrint()" label="Print" icon="fa fa-print"
      [customClass]="'primary-button'" [iconPosition]="'right'"> </ppl-button>
    </div>
    <div id="print-section">
      <form [formGroup]="invoiceForm" nz-form class="ppl-p0 m-4"
        nzLayout="vertical">
        <nz-row nzGutter="16">

          <!-- Consumer Select (non-staff view) -->
          @if(mode !== 'view' &&
          !staffView) {
          <nz-col nzXs="24" nzSm="12" nzMd="8">
            <nz-form-item class="ppl-form-item">
              <nz-form-label nzFor="consumer" class="ppl-form-label">
                Participant<span>*</span>
              </nz-form-label>
              <nz-form-control class="ppl-form-control">
                <nz-select formControlName="consumer" class="ppl-select"
                  nzId="consumer" nzPlaceHolder="Select Participant" nzShowSearch>
                  @for(opt of consumers; track $index){
                  <nz-option [nzLabel]="opt.consumerFullName"
                    [nzValue]="opt.consumerId">
                  </nz-option>
                  }
                </nz-select>

                <div *ngIf="invoiceForm.get('consumer')?.touched &&
                              invoiceForm.get('consumer')?.invalid"
                  class="error-message">
                  Participant is required.
                </div>

                <span *ngIf="!consumers || consumers.length == 0"
                  class="pl-1 error-message">
                  You don't have any active participants.
                </span>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          }

          <!-- Invoice Date -->
          <nz-col nzXs="24" nzSm="12" nzMd="8">
            <nz-form-item class="ppl-form-item">
              <nz-form-label nzFor="invoiceDate" class="ppl-form-label">
                Invoice Date<span>*</span>
              </nz-form-label>
              <nz-form-control class="ppl-form-control">
                <div nz-tooltip [nzTooltipTitle]="'Invoice Date'"
                  nzTooltipPlacement="topRight">
                  <ppl-date-picker formControlName="invoiceDate"
                    [id]="'invoiceDate'" [showIcon]="true"
                    (valueChange)="onInvoiceDateChange($event)"
                    [maxDate]="invoiceMaxEndDate"
                    dateFormat="mm/dd/yy" [yearRange]="'1900:2050'"
                    [iconDisplay]="'input'" inputId="icondisplay"
                    [panelStyleClass]="'custom-calendar-panel'"
                    [placeholder]="'Select'">
                  </ppl-date-picker>
                </div>

                <div *ngIf="invoiceForm.get('invoiceDate')?.touched &&
                            invoiceForm.get('invoiceDate')?.invalid"
                  class="error-message">
                  Invoice Date is required.
                </div>
              </nz-form-control>
            </nz-form-item>
          </nz-col>

          <!-- Invoice Number -->
          <nz-col nzXs="24" nzSm="12" nzMd="8">
            <nz-form-item class="ppl-form-item">
              <nz-form-label nzFor="invoiceNumber" class="ppl-form-label">
                Invoice Number
              </nz-form-label>
              <nz-form-control class="ppl-form-control">
                <div nz-tooltip [nzTooltipTitle]="'Invoice Number'"
                  nzTooltipPlacement="topRight">
                  <input nz-input formControlName="invoiceNumber"
                    id="invoiceNumber"
                    placeholder="Invoice Number" />
                </div>
              </nz-form-control>
            </nz-form-item>
          </nz-col>

        </nz-row>

        @if(mode === 'view' || mode === 'actions') {
        <nz-row>
          @if (selectedConsumer || invoiceData?.consumer) {
          <nz-form-item [nzSm]="4" [nzXs]="24" nzSpan="12" nz-col
            class="ppl-form-item nz-padding-left">
            <nz-form-label nzFor="ConsumerName"
              class="ppl-form-label"><b>Participant Name</b></nz-form-label>
            <nz-form-control class="ppl-form-control">
              <label id="ConsumerName">{{ selectedConsumer?.consumerFullName || invoiceData?.consumer?.consumerName || ''
                }}</label>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item [nzSm]="4" [nzXs]="24" nzSpan="12" nz-col
            class="ppl-form-item nz-padding-left">
            <nz-form-label nzFor="consumerId"
              class="ppl-form-label"><b>Participant
                PPL ID</b></nz-form-label>
            <nz-form-control class="ppl-form-control">
              <label id="consumerId">{{ selectedConsumer?.consumerPplId || invoiceData?.consumer?.consumerPplId || ''
                }}</label>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item [nzSm]="4" [nzXs]="24" nzSpan="12" nz-col
            class="ppl-form-item nz-padding-left">
            <nz-form-label nzFor="consumerId"
              class="ppl-form-label"><b>Participant
                UCI Number</b></nz-form-label>
            <nz-form-control class="ppl-form-control">
              <label id="consumerId">{{ selectedConsumer?.consumerUciNumber || invoiceData?.consumer?.uciNumber || ''
                }}</label>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item [nzSm]="6" [nzXs]="24" nzSpan="12" nz-col
            class="ppl-form-item nz-padding-left">
            <nz-form-label nzFor="consumerId"
              class="ppl-form-label"><b>Participant
                Regional Center</b></nz-form-label>
            <nz-form-control class="ppl-form-control">
              <label id="consumerId">{{ selectedConsumer?.regionalCenter || invoiceData?.consumer?.regionalCenter || ''
                }}</label>
            </nz-form-control>
          </nz-form-item>
          }

          @if (provider || invoiceData?.provider) {
          <nz-form-item [nzSm]="4" [nzXs]="24" nzSpan="12" nz-col
            class="ppl-form-item nz-padding-left">
            <nz-form-label nzFor="providerName"
              class="ppl-form-label"><b>Provider Name</b></nz-form-label>
            <nz-form-control class="ppl-form-control">
              <label id="providerName">{{ provider?.name ||
                provider?.providerFullName || invoiceData?.provider?.name || '' }}</label>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item [nzSm]="4" [nzXs]="24" nzSpan="12" nz-col
            class="ppl-form-item nz-padding-left">
            <nz-form-label nzFor="providerId" class="ppl-form-label"><b>Provider
                PPL ID</b></nz-form-label>
            <nz-form-control class="ppl-form-control">
              <label id="providerId">{{ provider?.providerPplId || invoiceData?.provider?.providerPplId || '' }}</label>
            </nz-form-control>
          </nz-form-item>
          }

          @if (provider?.phone || invoiceData?.provider?.phoneNumber){
          <nz-form-item [nzSm]="4" [nzXs]="24" nzSpan="12" nz-col
            class="ppl-form-item nz-padding-left">
            <nz-form-label nzFor="providerPhone"
              class="ppl-form-label"><b>Phone</b></nz-form-label>
            <nz-form-control class="ppl-form-control">
              <label id="providerPhone">{{ provider?.phone || invoiceData?.provider?.phoneNumber || '-' }}</label>
            </nz-form-control>
          </nz-form-item>
          }

          @if (provider?.address || invoiceData?.provider?.address){
          <nz-form-item [nzSm]="6" [nzXs]="24" nzSpan="12" nz-col
            class="ppl-form-item nz-padding-left">
            <nz-form-label nzFor="providerAddress"
              class="ppl-form-label"><b>Address</b></nz-form-label>
            <nz-form-control class="ppl-form-control">
              <label id="providerAddress">{{ provider?.address || invoiceData?.provider?.address || '' }}</label>
            </nz-form-control>
          </nz-form-item>
          }

          @if (provider?.email){
          <nz-form-item [nzSm]="4" [nzXs]="24" nzSpan="12" nz-col
            class="ppl-form-item nz-padding-left">
            <nz-form-label nzFor="providerEmail"
              class="ppl-form-label"><b>Email</b></nz-form-label>
            <nz-form-control class="ppl-form-control">
              <label id="providerEmail">{{ provider?.email || '' }}</label>
            </nz-form-control>
          </nz-form-item>
          }

          @if(invoiceData?.billingRate){
          <nz-form-item [nzSm]="4" [nzXs]="24" nzSpan="12" nz-col
            class="ppl-form-item nz-padding-left">
            <nz-form-label nzFor="billingRate"
              class="ppl-form-label"><b>Billing Rate</b></nz-form-label>
            <nz-form-control class="ppl-form-control">
              <label id="billingRate">{{ invoiceData?.billingRate || '' }}</label>
            </nz-form-control>
          </nz-form-item>
          }

          @if (invoiceData?.monthYear){
          <nz-form-item [nzSm]="4" [nzXs]="24" nzSpan="12" nz-col
            class="ppl-form-item nz-padding-left">
            <nz-form-label nzFor="monthYear"
              class="ppl-form-label"><b>Month/Year</b></nz-form-label>
            <nz-form-control class="ppl-form-control">
              <label id="monthYear">{{ invoiceData?.monthYear || '' }}</label>
            </nz-form-control>
          </nz-form-item>
          }
        </nz-row>
        }

        @if(mode === 'add') {
        <div class="custom-row" style="width: 100%; justify-content: left;">
          <ppl-button label=" Add a new line" icon="fa fa-plus"
            [customClass]="'primary-button'"
            (handleClick)="addNewLine()" [iconPosition]="'left'"></ppl-button>
        </div>
        }

        @if(showEntries) {

        @if(mode === 'actions' || mode === 'view' || staffView || providerView) {
        <div class="custom-row" style="overflow-x: auto; margin-top: 10px;">
          <div class="mr-2" *ngIf="mode === 'actions' && canApproveOrReject && !isReadOnly && canApproveReject">
            <ppl-button (click)="this.approveSelected()"
              style="margin-right: 8px;" label="Approve"
              [customClass]="'ghost-button'" [iconPosition]="'left'"></ppl-button>
          </div>

          <div [ngClass]="{'mr-2': staffView}" *ngIf="mode === 'actions' && canApproveOrReject && !isReadOnly && canApproveReject">
            <ppl-button (click)="this.denySelected()" [ngStyle]="{'margin-left':'0px'}"
              [ngClass]="{'act-btn-margin': staffView }" label="Deny"
              [customClass]="'ghost-button'" [iconPosition]="'left'"></ppl-button>
          </div>
          <div [ngClass]="{'mr-2': staffView && canEditInvoice }" *ngIf="mode === 'actions' && staffView && !isReadOnly">
            <ppl-button (click)="onSubmitAdjudicationClick()"
              [ngClass]="{'act-btn': staffView && canEditInvoice }" label="Submit for Processing"
              icon="fa fa-check-circle" [customClass]="'primary-button'"
              [iconPosition]="'right'"></ppl-button>
          </div>
          <div
            *ngIf="canEditInvoice && (mode === 'view' || mode === 'actions') && !isReadOnly">
            <ppl-button (click)="mode = 'edit'"
              label="Edit"
              icon="fa fa-pencil" [customClass]="'primary-button'"
              [iconPosition]="'right'"></ppl-button>
          </div>
        </div>
        }
        @if (mode === 'edit'){
        <div class="custom-row pr-3">
          <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'"
            [iconPosition]="'left'"
            (click)="providerView ? mode = 'view' : mode = 'actions'"></ppl-button>
        </div>
        }
        @if (mode === 'add' || mode === 'edit'){
        <div style="width: 100%">
          <table class="table mt-4 table-fixed">
            <thead>
              <tr>
                @if(mode !== 'add' && (mode === 'edit' || staffView || providerView)) {
                <th
                  style="width: 2%"><input
                    class="custom-checkbox" [ngStyle]="{'vertical-align' : 'middle'}" type="checkbox"
                    (change)="toggleSelectAll($event)"></th>
                }
                <th [ngStyle]="{'width' : '10%'}">Service
                  Date</th>
                <th style="width: 10%;">Service
                  Code</th>
                <th style="width: 10%;">Service
                  Description</th>
                <th style="width: 10%;">Task Description</th>
                <th style="width: 6%;">Time /
                  Units</th>
                <th style="width: 6%;">Rate</th>
                <th style="width: 8%;">Calculated
                  Cost</th>
                @if(mode !== 'add') {
                <th style="width: 8%;">Business
                  Status</th>
                <th style="width: 8%;">Processing
                  Status</th>
                }
                <th style="width: 8%;">
                  Comments</th>
                <th style="width: 5%;">Actions</th>
              </tr>
            </thead>
            <tbody formArrayName="invoiceEntries">
              <tr *ngFor="let entry of invoiceEntries.controls; let i = index"
                [formGroupName]="i">
                @if (mode !== 'add' && (mode === 'edit' || staffView || providerView)){
                <td><input
                    type="checkbox" class="custom-checkbox"
                    formControlName="selected">
                </td>
                }
                <td>
                  <ppl-date-picker formControlName="serviceDate"
                    [id]="'serviceDate' + i" [showIcon]="true"
                    dateFormat="mm/dd/yy" [yearRange]="'1900:2050'"
                    [iconDisplay]="'input'" inputId="icondisplay"
                    [panelStyleClass]="'custom-calendar-panel'"
                    [placeholder]="'Select'" [maxDate]="maxEndDate"
                    (valueChange)="onServiceDateChange($event)"
                    [ngClass]="{ 'error-border': isFormSubmitReequested && isFieldEmpty('serviceDate', i) }">
                  </ppl-date-picker>

                  @if(isFormSubmitReequested && isFieldEmpty('serviceDate', i)) {
                    <span class="pl-1 error-message">Service Date is required and must be on or before the Invoice Date.</span>
                  }
                </td>
                <td>
                  <nz-select class="ppl-select" formControlName="serviceCode"
                    nzPlaceHolder="Select Service" nzShowSearch
                    nzAllowClear
                    nzNotFoundContent="No service codes available. Please ensure the participant has sufficient authorization funds and rates for the selected service date."
                    [ngClass]="{ 'error-border': isFormSubmitReequested && isFieldEmpty('serviceCode', i) }">
                    <nz-option
                      *ngFor="let opt of getServiceCodeOptions(invoiceEntries.at(i))"
                      [nzLabel]="opt.serviceCodeDetail"
                      [nzValue]="opt.serviceCodeDetailId"></nz-option>
                  </nz-select>

                  @if(isFormSubmitReequested && isFieldEmpty('serviceCode', i)) {
                  <span class="pl-1 error-message">Service Code is
                    required.</span>
                  }
                </td>
                <td>
                  <nz-select class="ppl-select" formControlName="authIds"
                    nzPlaceHolder="Service Description"
                    nzShowSearch nzAllowClear
                    [ngClass]="{ 'error-border': isFormSubmitReequested && isFieldEmpty('authIds', i) }">
                    <nz-option
                      *ngFor="let opt of getServiceDescriptionOptions(invoiceEntries.at(i))"
                      [nzLabel]="opt.desc" [nzValue]="opt.ids"></nz-option>
                  </nz-select>

                  @if(isFormSubmitReequested && isFieldEmpty('authIds',
                  i)) {
                  <span class="pl-1 error-message">Service Description is
                    required.</span>
                  }
                </td>
                <td>
                  <!-- The selected authorization may carry no service details at all; in that case
                       the field is not applicable, so show "-" instead of an empty dropdown. -->
                  @if (hasServiceDetailOptions(invoiceEntries.at(i))) {
                  <nz-select class="ppl-select" formControlName="serviceDetailId"
                    nzPlaceHolder="Service Details"
                    nzShowSearch nzAllowClear
                    [ngClass]="{ 'error-border': isFormSubmitReequested && isFieldEmpty('serviceDetailId', i) }">
                    <nz-option
                      *ngFor="let opt of getServiceDetailOptions(invoiceEntries.at(i))"
                      [nzLabel]="opt.serviceDetail"
                      [nzValue]="opt.authProviderServiceId"></nz-option>
                  </nz-select>

                  @if(isFormSubmitReequested && isFieldEmpty('serviceDetailId',
                  i)) {
                  <span class="pl-1 error-message">Service Details is
                    required.</span>
                  }
                  } @else {
                  <span>-</span>
                  }
                </td>
                <td>
                  <input nz-input formControlName="serviceUnits"
                    id="serviceUnits{{i}}"
                    type="number"
                    [placeholder]="invoiceEntries.at(i).get('isMilageEntry')?.value === true ? 'Miles' : 'Units'"
                    [ngClass]="{ 'error-border': isFormSubmitReequested && isFieldEmpty('serviceUnits', i) }" />
                  @if(isFormSubmitReequested && isFieldEmpty('serviceUnits', i)) {
                  <span class="pl-1 error-message">Service Units is
                    required.</span>
                  } @else if(invoiceEntries.at(i).get('serviceUnits')?.errors?.['pattern']) {
                  <span class="pl-1 error-message">Up to 3 decimal places allowed.</span>
                  }
                </td>
                <td>
                  <ng-container *ngIf="isRateEditable(invoiceEntries.at(i))">
                    <input nz-input type="number" formControlName="rate" id="rate{{i}}"
                    [ngClass]="{ 'error-border': isFormSubmitReequested && isFieldEmpty('rate', i) }" />
                  </ng-container>
                  <ng-container *ngIf="!isRateEditable(invoiceEntries.at(i))">
                    <p class="mb-0">{{ invoiceEntries.get([i, 'rate'])?.value |
                      currency:'USD':'symbol':'1.2-3' }}</p>
                  </ng-container>
                  
                  @if(isFormSubmitReequested && isFieldEmpty('rate', i)) {
                  <span class="pl-1 error-message">Rate is required.</span>
                  }
                </td>
                <td>
                  <p class="mb-0"><strong>{{ invoiceEntries.get([i, 'totalCost'])?.value |
                      currency:'USD':'symbol':'1.2-3' }}</strong></p>

                  @if(isFormSubmitReequested && isFieldEmpty('totalCost', i)) {
                  <span class="pl-1 error-message">Total Cost is required and must
                    be greater than 0.</span>
                  }
                </td>
                @if(isDisabled) {
                <td>
                  <p>
                    {{ invoiceEntries.get([i, 'businessStatusLkp'])?.value || null
                    }}</p>
                </td>
                <td>
                  @if (invoiceEntries.get([i, 'processStatusLkp'])?.value ==
                  'Pended' || invoiceEntries.get([i, 'processStatusLkp'])?.value
                  ==
                  'Denied'){
                  <p class="success-status hyperlink"
                    (click)="viewInvoiceEntryStatusDetails(i)">
                    {{ invoiceEntries.get([i, 'processStatusLkp'])?.value || null
                    }}</p>
                  } @else {
                  <p>{{ invoiceEntries.get([i, 'processStatusLkp'])?.value || null
                    }}</p>
                  }

                </td>
                }
                <td>
                  <input nz-input formControlName="invoiceComments" id="comments{{i}}"
                    [ngClass]="{ 'error-border': isFormSubmitReequested && isFieldEmpty('invoiceComments', i) }" />
                  @if(isFormSubmitReequested && isFieldEmpty('invoiceComments', i)) {
                  <span class="pl-1 error-message">Comments is required.</span>
                  }
                </td>
              @if(canDuplicateEntry || canDeleteEntry(i)){
                <td>
                  <div class="custom-btn-row">
                    @if(canDuplicateEntry){
                    <div nz-tooltip [nzTooltipTitle]="'Duplicate'"
                      class="tooltip-container mr-2">
                      <ppl-button label (click)="duplicateRow(i)" icon="fa fa-clone"
                        [customClass]="'ghost-button'"
                        [iconPosition]="'left'"></ppl-button>
                    </div>
                    }
                    @if(canDeleteEntry(i)){
                    <div nz-tooltip [nzTooltipTitle]="'Delete'"
                      class="tooltip-container mr-2">
                      <ppl-button label (click)="deleteRow(i)" icon="pi pi-trash"
                        [customClass]="'ghost-button'"
                        [iconPosition]="'left'"></ppl-button>
                    </div>
                    }
                  </div>
                </td>
                }
                @else {
                <td></td>
                }
              </tr>
            </tbody>
          </table>
        </div>
        }
        @else{
        <div class="table-wrapper">
          <table class="table mt-4 table-fixed table-view">
            <thead>
              <tr>
                @if(mode === 'actions' || staffView || providerView) {
                <th
                  style="min-width: 4%"><input
                    class="custom-checkbox" [ngStyle]="{'vertical-align' : 'middle'}" type="checkbox"
                    (change)="toggleSelectAll($event)"></th>
                }
                <th [ngStyle]="{'min-width' : '10%'}">Service
                  Date</th>
                <th style="min-width: 6%;">Submission
                  Date</th>
                <th style="min-width: 10%;">Service
                  Code</th>
                <th style="min-width: 10%;">Service
                  Description</th>
                <th style="min-width: 10%;">Task Description</th>
                <th style="min-width: 6%;">Time / Units</th>
                <th style="min-width: 6%;">Rate</th>
                <th style="min-width: 8%;">Calculated
                  Cost</th>
                <th style="min-width: 8%;">Comments</th>
                <th style="min-width: 8%;">Business
                  Status</th>
                <th style="min-width: 8%;">Processing
                  Status</th>
                <th style="min-width: 8%;">Regional
                  Center</th>
                <th style="min-width: 4%;">Decision
                  Timestamp</th>
                @if(!isExternal) {
                <th style="min-width: 4%;">Decision
                  By</th>
                }
                @if (staffView){
                <th style="min-width: 4%;">Authorization
                  Number</th>
                <th>Actions</th>
                }

              </tr>
            </thead>
            <tbody formArrayName="invoiceEntries">
              <tr *ngFor="let entry of invoiceEntries.controls; let i = index"
                [formGroupName]="i">
                <td *ngIf="mode === 'actions' || staffView || providerView"><input
                    type="checkbox" class="custom-checkbox"
                    formControlName="selected">
                </td>
                <td>
                  {{invoiceEntries.get([i, 'serviceDate'])?.value |
                  date:'MM/dd/yyyy'}}
                </td>
                <td>
                  <span [title]="invoiceEntries.get([i, 'createdDate'])?.value">{{
                    invoiceEntries.get([i, 'createdDate'])?.value || null
                    }}</span>
                </td>
                <td>
                  {{invoiceEntries.get([i, 'serviceCodeDescription'])?.value}}
                </td>
                <td>
                  {{ invoiceEntries.get([i, 'planServiceCode'])?.value}}
                </td>
                <td>
                  {{ invoiceEntries.get([i, 'taskDescription'])?.value || '-' }}
                </td>
                <td>
                  {{ invoiceEntries.get([i, 'serviceUnits'])?.value }}
                </td>
                <td>
                  {{ invoiceEntries.get([i, 'rate'])?.value | currency:'USD':'symbol':'1.2-3' }}
                </td>
                <td>
                  <strong>{{ invoiceEntries.get([i, 'totalCost'])?.value |
                    currency:'USD':'symbol':'1.2-3' }}</strong>
                </td>
                <td>
                  {{ invoiceEntries.get([i, 'invoiceComments'])?.value || '-' }}
                </td>
                <td>
                  {{ invoiceEntries.get([i, 'businessStatusLkp'])?.value || null
                  }}
                </td>
                <td>
                  @if (invoiceEntries.get([i, 'processStatusLkp'])?.value ==
                  'Pended' || invoiceEntries.get([i, 'processStatusLkp'])?.value
                  ==
                  'Denied'){
                  <span class="success-status hyperlink"
                    (click)="viewInvoiceEntryStatusDetails(i)">
                    {{ invoiceEntries.get([i, 'processStatusLkp'])?.value || null
                    }}</span>
                  } @else {
                  {{ invoiceEntries.get([i, 'processStatusLkp'])?.value || null
                  }}
                  }
                </td>
                <td>
                  {{ invoiceEntries.get([i, 'mcoName'])?.value || '-' }}
                </td>
                <td>
                  <p>{{ invoiceEntries.get([i, 'consumerDecisionDate'])?.value ||
                    null }}</p>
                </td>
                @if(!isExternal) {
                <td>
                  <p>{{ invoiceEntries.get([i, 'consumerDecisionBy'])?.value ||
                    null }}</p>
                </td>
                }
                @if(staffView){
                <td>
                  @if (invoiceEntries.get([i, 'authIds'])?.value){
                  <p class="success-status hyperlink"
                    (click)="onOpenAuthDataClicked(i)">
                    view
                  </p>
                  }
                  @else{
                  <p>-</p>
                  }
                </td>
                <td class="action-container">
                  <ppl-button
                    [ariaLabel]="'Edit History'"
                    label="Edit History" [customClass]="'ghost-button'"
                    [iconPosition]="'left'"
                    (click)="openInvoiceEditHistoryDialog(i)"></ppl-button>

                  <ppl-button
                    [ariaLabel]="'Audit History'"
                    label="Audit History" [customClass]="'ghost-button'"
                    [iconPosition]="'left'"
                    (click)="openAuditHistoryDialog(i)"></ppl-button>
                </td>
                }
              </tr>
            </tbody>
          </table>
        </div>
        }

        <nz-row class="ppl-mt10 ppl-mb10 mt-4" style="text-align: right;">
          <nz-col [nzSpan]="24" class="text-right">
            @if (mode !== 'add') {
            <b>Total Invoice Submitted: {{ getTotalInvoiceAmount() |
              currency:'USD':'symbol':'1.2-3' }}</b><br>
            <b>Total Invoice Paid: {{ getTotalInvoicePaid() |
              currency:'USD':'symbol':'1.2-3' }}</b>
            } @else {
            <b>Total Invoice Amount: {{ getTotalInvoiceAmount() |
              currency:'USD':'symbol':'1.2-3' }}</b>
            }
          </nz-col>
        </nz-row>

        <div nz-col [nzSm]="12" [nzXs]="24">
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSpan]="24" class="ppl-form-label">
            </nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              @if(isDisabled) {
              <p style="font-size:0.929rem; font-weight: 600;">Receipt
                Attachments</p>
              } @else {
              <p style="font-size:0.929rem; font-weight: 600; margin-bottom: 4px;">Attach Receipt*</p>
              }
              @if (hasMilageEntries && !isDisabled) {
                @if(isIndependentProvider()){
                  <p class="error-message"
                    style="font-size:0.857rem; margin: 0 0 8px;">
                      Receipt attachment should be a maps document such as
                      "Google Maps" and cannot include your commute.
                  </p>
                }
                @else {
                  <p class="error-message"
                    style="font-size:0.857rem; margin: 0 0 8px;">
                    Attach the invoice or receipt for the transportation provided.
                  </p>
                }
              }
              <ppl-upload [showFileList]="true" [docTypeList]="invoiceDocTypes"
                [disableUploadButton]="canDisableUploadAttachments()"
                [leadId]="providerId.toString()" [showFileList]="true"
                [fileList]="uploadedFiles"
                [consumerId]="invoiceForm.getRawValue().consumer"
                [providerId]="providerId?.toString()" [source]="'invoice'"
                (fileSelected)="onFileSelected($event)"
                (fileRemoved)="onFileRemoved($event)"
                (downloadRequested)="onDownloadRequested($event)"
                [mode]="mode"></ppl-upload>

              @if (isFormSubmitReequested && missingRequiredDocTypes.length > 0) {
              <span class="pl-1 error-message">An attachment is required for each of these document
                types: {{ missingRequiredDocTypes.join(', ') }}.</span>
              }
            </nz-form-control>
          </nz-form-item>
        </div>

        @if(mode === 'add') {
        <div class="attestation-row">
          <label class="attestation-label">
            <input type="checkbox" class="custom-checkbox"
              id="attestation" formControlName="attestation">
            <span>All documents provided are accurate to best of my
              knowledge<span class="required-mark">*</span></span>
          </label>
          @if(isFormSubmitReequested && !isAttested) {
          <div class="pl-1 error-message">
            You must confirm the above statement before submitting.
          </div>
          }
        </div>
        }

        @if(mode === 'add' || mode === 'edit' || canUpdateEntries) {
        <div class="custom-row" style="width: 100%;">
          @if(staffView && mode === 'edit') {
          <ppl-button (click)="onMoveBack()" style="margin-right: 8px;"
            label="Move Back"
            icon="fa fa-check-circle" [customClass]="'primary-button'"
            [iconPosition]="'right'"></ppl-button>
          }
          @if(canUpdateEntries && (mode === 'add' || mode === 'edit')){
          <div class="mr-2">
            <ppl-button (click)="this.onSave()" [disabled]="!isAttested"
              style="margin-right: 8px; font-size: 1rem" label="Submit"
              icon="fa fa-check-circle" [customClass]="'primary-button'"
              [iconPosition]="'left'"></ppl-button>
          </div>
          }
          @if (mode === 'add'){
          <div class="mr-2">
            <ppl-button label="Close"
              [customClass]="'ghost-button justify-center'"
              icon="fa fa-times-circle-o"
              [iconPosition]="'left'" (click)="onCancel()"
              style="white-space: nowrap; font-size: 1rem"></ppl-button>
          </div>
          }
        </div>
        }
        }
      </form>
    </div>
  </div>
</div>

<div class="filter-panel">
  <ng-template #denyDialog let-cancel="cancel">
    <p>Reason: </p>
    <nz-select nzPlaceHolder="Select Reason" [(ngModel)]="selectedReason"
      style="width:100%; margin-bottom: 16px"
      nzShowArrow>
      @for(item of listOfOption; track $index ){
      <nz-option [nzLabel]="item" [nzValue]="item"></nz-option>
      }
    </nz-select>
  </ng-template>
</div>
<div class="filter-panel">
  <ng-template #pendedDialog let-cancel="cancel">
    <ppl-invoice-staff-errorcode [errorcodeData]="errorcodeData"
      (onSaveComplete)="onSaveAdjustment($event)"
      [disabled]="!staffView"></ppl-invoice-staff-errorcode>
  </ng-template>
</div>
<div class="filter-panel">
  <ng-template #deniedDialog let-cancel="cancel">
    <ppl-timesheet-staff-deniedreasons
      [deniedData]="deniedData"></ppl-timesheet-staff-deniedreasons>
  </ng-template>
</div>
<div class="filter-panel">
  <ng-template #authUsageDataDialog let-cancel="cancel">
    <ppl-timesheet-staff-authdata [authData]="authUsageData"
      (showAuthDetails)="showAuthDetails($event)"></ppl-timesheet-staff-authdata>
  </ng-template>
</div>
<div class="filter-panel">
  <ng-template #authDialog let-cancel="cancel">
    <ppl-authorization-details [authorizationId]="selectedAuthorizationId"
      [pageSource]="'invoice'" [isReadOnly]="true"></ppl-authorization-details>
  </ng-template>
</div>
<div class="filter-panel">
  <ng-template #invoiceAuditHistoryDialog let-cancel="cancel">
    <ppl-audit-history [auditEntryId]="selectedInvoiceLineId" [flow]="'invoice'" [programCode]="programName"></ppl-audit-history>
  </ng-template>
</div>
<div class="filter-panel">
    <ng-template #invoiceEditHistoryDialog let-cancel="cancel">
        <ppl-invoice-edit-history-view [invoiceLineId]="selectedInvoiceLineId"></ppl-invoice-edit-history-view>
    </ng-template>
</div>
